import axios from '@/utils/axios';

// Types

// API

export default {
	async GetAllSubFamilies(targetDate :Date | null): Promise<any> {
		if (targetDate == null){
			targetDate = new Date;
		}
		var targetDateString =targetDate.getFullYear()+"-"+(targetDate.getMonth()+1)+"-"+targetDate.getDate() ;
		return (await axios().get(`/subfamilies/?targetDate=${targetDateString}`)).data;
		
	},

};
